import React, { ReactNode } from "react";

interface ConditionalWrapperProps {
  condition: boolean;
  wrap: (children: ReactNode) => ReactNode;
  children: NonNullable<ReactNode>;
}

const ConditionalWrapper = ({ condition, wrap, children }: ConditionalWrapperProps) => (
  <>{condition ? wrap(children) : children}</>
);

export default ConditionalWrapper;
